import 'Styles/templates/product.product-new.scss';

import pdpNew from '../vue/pdp-new';
import StickyBar from '../components/sticky-bar-new';
import productSliderApp from '../vue/product-slider/index';
import recentlyViewedApp from '../vue/recently-viewed/index';
import AutoplayVideo from '../components/autoplay-video';

pdpNew();
StickyBar();
productSliderApp();
recentlyViewedApp();
AutoplayVideo();
